import React, { useContext, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../../assets/css/animate.min.css';
import '../../assets/css/bootstrap.css';
import '../../assets/css/style.css';
import '../../assets/css/font-awesome.min.css';
import { FaBars, FaTimes } from "react-icons/fa";
import { LoginContext } from '../../context/LoginContext';
import { getUserStatus } from '../../utils/onboarding';
import { brandLogo, brandFallback } from '../../constants/brandAssets';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, userData, isLoggedIn } = useContext(LoginContext);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goLogin = (e) => {
    e.preventDefault();
    // Clear stale pending session so approved users can log in fresh
    if (isLoggedIn && getUserStatus(userData) === 3) {
      logout();
    }
    navigate('/login');
    setIsMenuOpen(false);
  };

  return (
    <div className="header-container">
      <div className="hom-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="hom-nav col-12">
              <div className='row align-items-center'>
                <div className='col-6 col-md-6'>
                  <div className="logo">
                    <Link to="/">
                    <img
                      src={brandLogo}
                      alt="Hindu Sanjog Logo"
                      className="img-fluid"
                      onError={(e) => {
                        if (e.currentTarget.src !== brandFallback) {
                          e.currentTarget.src = brandFallback;
                        }
                      }}
                    />
                    </Link>
                  </div>
                </div>

                <div className='col-6 col-md-6 d-flex justify-content-end'>
                  {/* Desktop buttons - hidden on mobile */}
                  <div className='button-place d-none d-md-block'>
                    <div className='button-container'>
                      <Link to="/login?mode=signup">
                        <button type="button" className="btn-signup me-2">Sign Up</button>
                      </Link>
                      <button type="button" className='btn-login' onClick={goLogin}>Login</button>
                    </div>
                  </div>

                  {/* Mobile menu toggle - hidden on desktop */}
                  <div className='d-md-none'  >
                    <button
                      className="menu-toggle btn btn-outline-primary"
                      onClick={toggleMenu}
                      aria-expanded={isMenuOpen}
                      aria-label="Toggle navigation"

                    >
                      <i >   {isMenuOpen ? <FaTimes /> : <FaBars style={{color:"#e53d5c"}}/>}</i>
                    </button>
                  </div>
                </div>

                {/* Mobile menu - appears below on toggle */}
                {isMenuOpen && (
                  <div className='col-12 d-md-none mt-2'>
                    <div className='mobile-menu bg-light p-2 rounded'>
                      <div className='d-flex gap-5'>
                        <Link to="/login?mode=signup" className='btn btn-signup' >Sign Up</Link>
                        <button type="button" className='btn btn-login' onClick={goLogin}>Login</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
